import { createSelector } from "reselect";

const selectTechReducer = (state) => state.tech;

export const selectTechnician = createSelector([selectTechReducer], (application) => application.technician);
export const selectLoginError = createSelector([selectTechReducer], (application) => application.loginError);
export const selectLoginLoading = createSelector([selectTechReducer], (application) => application.loginLoading);
